/**
 * `crypto.randomUUID`, everywhere.
 *
 * The built-in exists only in secure contexts — https or localhost. Served over plain http on
 * an office LAN (`http://192.168.…:8080`, which is exactly how the demo box is reached), it is
 * `undefined`, and the first casualty was the «Εξόφληση» dialog minting its idempotency key.
 * `getRandomValues` has no such restriction, so the fallback assembles the same v4 UUID from it.
 */
export function randomUUID(): string {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // variant 10

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
